import { useSelector } from 'react-redux';

/** Active market from the header country selector (LK, SG, …). */
export const useDashboardMarket = () => useSelector(
  (state) => state?.locationMeta?.data?.country_shortCode || null,
);

export default useDashboardMarket;
